import {REQUEST, RESPONSE, FILTER, SELECT_PARENT, INVALIDATE} from './SimpleListActions'
import {INIT_REDUCER} from "./../../shared/SharedActions";

const simpleFilter = (rows, filter) => rows

function getDataKey() {
    let dataKey = "";

    // Filter
    dataKey += JSON.stringify(this.filter);

    // Parent
    dataKey += "_" + this.parent;

    // Stránkování, pokud je povoleno
    if (this.supportPaging) {
        dataKey += "_" + this.paging.getDataKey();
    }

    // ---

    return dataKey;
}

const initialState = {
    sourceRows: [], // zdrojové řádky
    filteredRows: [], // filtrované řádky
    count: 0,
    rows: [],   // vyfiltrované řádky a případně jinak upravené řádky = určené pro konkrétní zobrazení
    isFetching: false,
    fetched: false,
    filter: {},
    filterRows: simpleFilter,
    currentDataKey: "",
    getDataKey: getDataKey,
    reducer: list,
    parent: null,
}

export default function list(state = initialState, action = {}, config = null) {
    // Konfigurace
    if (config) {
        state = {...state}

        if (config.filterRows) {    // metoda pro filtr
            state.filterRows = config.filterRows
        }
        if (config.filter) {    // inicializační filtr
            state.filter = config.filter
        }
    }

    switch (action.type) {
        case INIT_REDUCER:
            return {
                ...action.store
            };
        case REQUEST:
            return {
                ...state,
                isFetching: true,
                currentDataKey: action.dataKey,
            };
        case SELECT_PARENT:
            return {
                ...state,
                parent: action.parent,
                fetched: false,
                isFetching: false,
                sourceRows: [],
                filteredRows: [],
                rows: [],
                count: 0
            };
        case INVALIDATE: {
            return {
                ...state,
                currentDataKey: initialState.currentDataKey,
            }
        }
        case RESPONSE: {
            let sourceRows = action.rows
            let filteredRows = state.filterRows(sourceRows, state.filter)
            let rows = filteredRows

            return {
                ...state,
                isFetching: false,
                fetched: true,
                sourceRows: sourceRows,
                filteredRows: filteredRows,
                rows: rows,
                count: action.count,
            }
        }
        case FILTER: {
            let filteredRows = state.filterRows(state.sourceRows, action.filter)
            let rows = filteredRows

            return {
                ...state,
                filter: action.filter,
                filteredRows: filteredRows,
                rows: rows,
            }
        }
        default:
            return state
    }
}
